import { alpha, Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { DashboardCardDetailButton } from "web_myplann/Dashboard/Components/DashboardCardDetailButton";
import { DashboardGoalsCardItem } from "web_myplann/Dashboard/Components/DashboardGoalsCardItem";
import { DashboardGoalsList } from "web_myplann/Dashboard/Components/DashboardGoalsList";
import { DashboardMoreGoalsRing } from "web_myplann/Dashboard/Components/DashboardMoreGoalsRing";
import type { DashboardGoalsSlide } from "web_myplann/Dashboard/Types/DashboardSlide";
import { DASHBOARD_CARD_VALUE_BLOCK_HEIGHT } from "web_myplann/Dashboard/Utils/dashboardLayout";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

const GoalsCardResources = Resources.Dashboard.GoalsCard;

type Props = {
	slide: DashboardGoalsSlide;
	navigateToDashboardDetail?: () => void;
};

export const DashboardGoalsCardContent: FC<Props> = ({
	slide,
	navigateToDashboardDetail,
}) => {
	const { t } = useResource();
	const { palette, spacingTokens } = useTheme();
	const navigate = useNavigate();

	const { goals, totalCount } = slide.goalOverview;
	const remainingCount = totalCount - goals.length;

	return (
		<Stack width="100%" height="100%" alignItems="center" pt={spacingTokens.sm}>
			<Stack
				height={DASHBOARD_CARD_VALUE_BLOCK_HEIGHT}
				alignItems="center"
				justifyContent="flex-end"
				gap={spacingTokens.sm}
			>
				<Typography
					variant="bodyMedium"
					color={alpha(palette.darkmodeText.white, 0.8)}
				>
					{t(GoalsCardResources.title)}
				</Typography>
				<Stack direction="row" justifyContent="center" gap={spacingTokens.sm}>
					<DashboardGoalsList goals={goals} />
					{remainingCount > 0 && (
						<DashboardGoalsCardItem
							ring={<DashboardMoreGoalsRing />}
							value={t(GoalsCardResources.moreGoalsCount, {
								count: remainingCount,
							})}
							label={t(GoalsCardResources.moreGoals, {
								count: remainingCount,
							})}
							onClick={() => navigate(Routing.Goals.GoalsList.path())}
						/>
					)}
				</Stack>
			</Stack>
			{navigateToDashboardDetail && (
				<DashboardCardDetailButton
					gradientFrom={slide.gradientFrom}
					onClick={navigateToDashboardDetail}
				/>
			)}
		</Stack>
	);
};
